import t from "react";
import p from "classnames";
import { T as r } from "./index-Dd-4N6BE.es.js";
import { u as c } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Chips.css';const i = "Chips-module__chips___xNdHT", m = "Chips-module__chip___jN8Kk", _ = "Chips-module__dark___-bDc9", s = {
  chips: i,
  chip: m,
  dark: _
}, d = ({
  chips: o
}) => {
  const a = c();
  return /* @__PURE__ */ t.createElement("div", { className: s.chips }, o.map((e) => /* @__PURE__ */ t.createElement(
    r.Body3,
    {
      key: e.text,
      className: p([s.chip, a && s.dark]),
      responsive: !0
    },
    e.text
  )));
};
d.displayName = "Chips";
export {
  d as C
};
